<template>
	<div class="card-base card-shadow--medium mb-20 widget small-widget" >
		<div class="widget-header ph-20 pt-20">
			<div class="flex justify-center align-center">
				<div class="widget-icon-box mr-20 animated fadeInRight">
					<i v-bind:class="getIconBadgeBoxClass"></i>
					<div class="badge-box">
						<span v-if="percentage" class="badge"><i v-bind:class="getTrendBadgeBoxClass"></i><strong v-if="percentage" v-bind:class="getTextColorClass">{{percentage}}%</strong></span>
					</div>
				</div>
				<div class="widget-info box grow text-truncate animated fadeInLeft">
					<div class="o-050 widget-title text-truncate pt-5 pb-10">{{text}}</div>
					<h2 class="m-0 text-truncate">{{total}}</h2>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'IntoStatCard',
	props : {
		percentage : String,
		total : String,
		icon : String,
		trend : String,
		sign : String,
		text : String,
		status : String
	},
	computed : {
		getIconBadgeBoxClass(){
			return "widget-icon mdi "+ this.icon + " " + this.getTextColorClass+ " fs-30";
		},
		getTrendBadgeBoxClass(){
			return "mdi "+this.trend+ " "+this.getTextColorClass + " mr-10";
		},
		getTextColorClass(){
			return this.status + "-text";
		}
	},

}
</script>
</script>

<style lang="scss" scoped>

.widget {
	height: 125px;
	position: relative;

	.widget-header {

		.widget-icon-box {
			background: rgba(0, 0, 0, .02);
			border: 1px solid rgba(0, 0, 0, .02);
			border-radius: 4px;
			text-align: center;
			width: 60px;
			padding: 5px;
		}

		.widget-title {
			font-weight: bold;
		}
	}

	.badge-box {
		.badge {
			//background: rgba(0, 0, 0, .02);
			display: inline-block;
			//padding: 2px 5px;
			//border: 1px solid rgba(0, 0, 0, .02);
			border-radius: 4px;
			font-size: 80%;
		}
	}
}
</style>
